import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { contentCountsRequest } from '../../actions/spaces/ContentCountsActions';
import { addSiteUsersToGroup } from '../../actions/spaces/GroupMenuActions';
import { selectContentCounts, selectContentCountsUpToDate } from '../../selectors/ContentCountsSelector';
import { SessionUserSelectors } from '../../selectors/SessionInfoSelectors';
import { selectSpaceInfo } from '../../selectors/SpaceInfoSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { GroupSpace, GroupSpaceDispatchProps, GroupSpaceStateProps } from './GroupSpace';

const mapStateToProps: MapStateToProps<GroupSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  contentCounts: selectContentCounts<'group'>(state, 'group'),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  canSessionUserManageUsers: SessionUserSelectors.canManageUsers(state),

});

const mapDispatchToProps: MapDispatchToProps<GroupSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest,
    addSiteUsersToGroup: addSiteUsersToGroup
  },
  dispatch);

export const ConnectedGroupSpace = connect(mapStateToProps, mapDispatchToProps)(GroupSpace);
